// The last in-galaxy screen that is not the Menu, per galaxy: the Menu is where feedback is sent
// from, so the feedback names the screen the tester came from instead.
import { create } from 'zustand';

interface LastScreenState {
  byGalaxy: Record<string, string>;
  set(galaxyId: string, pathname: string): void;
}

export const useLastScreen = create<LastScreenState>()((set) => ({
  byGalaxy: {},
  set: (galaxyId, pathname) =>
    set((state) =>
      state.byGalaxy[galaxyId] === pathname
        ? state
        : { byGalaxy: { ...state.byGalaxy, [galaxyId]: pathname } }
    ),
}));
